// extracted by mini-css-extract-plugin
export var externalLink = "_d7-0";
export var internalLinkLabel = "_d7-1";